import { DoorOpen, Rocket, Handshake, Crosshair } from "lucide-react";

const PROMISES = [
  {
    icon: DoorOpen,
    num: "01",
    title: "We Own the Network",
    line: "You cannot get these affiliates anywhere else.",
    desc: "Social Flats has exclusive access to every affiliate in the network. No other platform, no back channels. We are the only door in — and when you join, it opens for you.",
  },
  {
    icon: Rocket,
    num: "02",
    title: "Start Making Money Day One",
    line: "Earn from day one — not day thirty.",
    desc: "We set you up completely from the moment you sign. Ready-made ads, full onboarding, tracking in place. You don't build the machine — you switch it on.",
  },
  {
    icon: Handshake,
    num: "03",
    title: "We're In Your Corner",
    line: "This isn't sign up and figure it out yourself.",
    desc: "You get the best information, tools and support from a team that wins when you win. Real answers, real strategy, real backing — from your first click to your biggest month.",
  },
  {
    icon: Crosshair,
    num: "04",
    title: "You Focus on Traffic. We Handle the Rest.",
    line: "Ads. Strategy. Training. Social growth. Handled.",
    desc: "Our team runs the playbook behind you — creatives, campaign strategy, training and growing your social presence. Your only job is to bring the audience.",
  },
];

export const WhySection = () => (
  <section data-testid="why-section" className="max-w-7xl mx-auto px-4 sm:px-8 mt-24">
    <div className="max-w-3xl mb-14">
      <p className="uppercase text-xs tracking-[0.2em] font-semibold text-emerald-600 mb-3">Why Social Flats</p>
      <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-[1.05]">
        This is not another affiliate site.<br />
        <span className="text-emerald-600">This is the inside track.</span>
      </h2>
    </div>

    <div className="border-t border-slate-200">
      {PROMISES.map(({ icon: Icon, num, title, line, desc }) => (
        <div
          key={num}
          data-testid={`why-promise-${num}`}
          className="group grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-8 py-10 border-b border-slate-200 items-start"
        >
          <div className="lg:col-span-1 flex lg:block items-center gap-4">
            <span className="font-heading text-4xl font-light text-slate-300 group-hover:text-emerald-600 transition-colors duration-200">{num}</span>
          </div>
          <div className="lg:col-span-5 flex items-start gap-4">
            <div className="bg-slate-900 rounded-lg p-3 shrink-0 group-hover:bg-emerald-600 transition-colors duration-200">
              <Icon className="w-6 h-6 text-emerald-400 group-hover:text-white transition-colors duration-200" strokeWidth={1.8} />
            </div>
            <div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold tracking-tight leading-snug">{title}</h3>
              <p className="text-sm font-semibold text-emerald-700 mt-1">{line}</p>
            </div>
          </div>
          <div className="lg:col-span-6">
            <p className="text-slate-600 leading-relaxed">{desc}</p>
          </div>
        </div>
      ))}
    </div>

    <p className="font-heading text-2xl md:text-3xl tracking-tight mt-12 max-w-2xl">
      If you have an audience, joining is a <span className="text-emerald-600 font-semibold">no-brainer</span>. The door is right below.
    </p>
  </section>
);
